{
  "foo": "BAR",
  "search": {
    "title": "Suche"
  }
}
